  import type { HTMLAttributes, CSSProperties } from "react";
  import onflyLogo from "../assets/onfly-logo.webp";
  import onflyLogoBlue from "../design-system/assets/logos/Onfly_Logo_Blue.svg";
  import "./OnflyLogo.css";

  interface OnflyLogoProps extends Omit<HTMLAttributes<HTMLSpanElement>, "height"> {
    dark?: boolean;
    height?: number | string;
    /** "legacy" = PNG antigo (login). "ds" = SVG azul do design system (telas internas, sempre azul). */
    variant?: "legacy" | "ds";
  }

  export const OnflyLogo = ({ dark = false, height, style, variant = "legacy", ...rest }: OnflyLogoProps) => {
    const className = `onfly-logo${dark ? " onfly-logo--dark" : ""}`;
    const imgHeight = height
      ? (typeof height === "number" ? `${height}px` : height)
      : undefined;

    const src = variant === "ds" ? onflyLogoBlue : onflyLogo;

    return (
      <span {...rest} className={className} style={style}>
        <img src={src} alt="Onfly" style={{ height: imgHeight, width: "auto" }} />
      </span>
    );
  };

  export default OnflyLogo;
